var crValidateDelivery = true;

//var crReloadOnError = true;
//var crdebug = true;

// var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
//   console.log(selectedDay, selectedDate, selectedMonth);
//   if(selectedDate.getDate() === 24 && selectedMonth === 11 && selectedDate.getFullYear() === 2025) {  	
//     timepicker.set('min',[13, 0]); 
//     timepicker.set('max',[17, 0]);
//   }
	
// }

// continuosly check if the fields are completed
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
  
    disableCheckoutButton2();
    var tt = setInterval(function(){
      disableCheckoutButton2();
      //console.log('check.............')
      var fieldsCorrect = checkPickupFields();
      //console.log({fieldsCorrect})
      if (fieldsCorrect === true) {
        //clearInterval(tt);  
      }
      
    }, 1000);
    //setTimeout(function() { clearInterval(tt); }, 5000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  jqCR(document).on('change', '#pickup-selected-store', function(){
    updateThreeLakesCartGuard();
    checkPickupFields();
  })  
  trackChange(jqCR("#pickup-selected-store")[0] );  

   jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
   trackChange(jqCR("#note-pickup-date")[0] );
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function isThreeLakesSelected(){
    var storeField = jqCR('#pickup-selected-store');
    var selectedText = '';

    if (storeField.length) {
      selectedText += ' ' + (storeField.val() || '');
      selectedText += ' ' + (storeField.find('option:selected').text() || '');
      selectedText += ' ' + (storeField.text() || '');
    }

    selectedText += ' ' + (jqCR('#pickup-selected-store-id').val() || '');
    selectedText = selectedText.toLowerCase();

    return selectedText.indexOf('three lakes') !== -1 || selectedText.indexOf('tamiami') !== -1 || selectedText.indexOf('128th') !== -1;
}

function threeLakesCartIsEligible(){
    var guard = document.querySelector('#lm-three-lakes-cart');
    if (!guard) return true;
    return guard.getAttribute('data-three-lakes-eligible') === 'true';
}

function updateThreeLakesCartGuard(){
    var guard = document.querySelector('#lm-three-lakes-cart');
    if (!guard) return true;

    var blocked = isThreeLakesSelected() && !threeLakesCartIsEligible();
    guard.classList.toggle('lm-three-lakes-cart--selected-blocked', blocked);

    if (blocked) {
      disableCheckoutButton2();
      return false;
    }
    return true;
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val();

    if (updateThreeLakesCartGuard() === false) {
      return false;
    }

    if (pickupDate && selectedStoreId && phone) {
      activateCheckoutButton2();
      return true;
    }
    disableCheckoutButton2()
    return false;
}

function activateCheckoutButton2(){
  //console.log('Activate')
      document.querySelector('#checkout').disabled = false;
  }

function disableCheckoutButton2(){    
    document.querySelector('#checkout').disabled = true;
}

document.addEventListener('crDeliveryActivated', function (e) {
    activateCheckoutButton2()
})